module.exports = __webpack_public_path__ + "img/wrongQuestion-noData.b84d51a3.png";